import React, { useCallback, useEffect } from 'react'
import { useAppSelector } from './ReduxHooks'

type Args = {
	auto?: boolean
}

export const useBrowserTabInit = ({ auto = true }: Args) => {
	const { assets, meta } = useAppSelector(s => s.settings)
	useEffect(() => {
		if (auto) updateFavicon()
	}, [assets.favicon])

	useEffect(() => {
		if (auto) updateDocumentTitle()
	}, [meta?.title])

	const updateFavicon = useCallback(() => {
		// Bail before touching the DOM when the slot is empty — never set, or
		// cleared from admin Settings. Assigning `undefined` stringified to
		// href="undefined", pointing the tab icon at /undefined, which the SPA
		// answers with index.html. Leaving the tag alone lets the browser fall
		// back to its own default. Mirrors the admin/instructor hooks.
		if (!assets.favicon) return

		let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement
		if (!link) {
			link = document.createElement('link')
			link.rel = 'icon'
			document.getElementsByTagName('head')[0].appendChild(link)
		}

		link.href = assets.favicon
	}, [assets.favicon])

	const updateDocumentTitle = useCallback(() => {
		/* tenant/mribrahimfarid: fall back to the static brand title instead of
		   blanking the tab when admin meta_title is unset. */
		document.title = meta?.title ?? 'مستر إبراهيم فريد — لغة إنجليزية للثانوية'
	}, [meta?.title])

	const resetAppMeta = () => {
		updateFavicon()
		updateDocumentTitle()
	}

	return { resetAppMeta }
}
